export default {"src":"/_next/static/media/dash.1c92fee4.svg","height":46,"width":113,"blurWidth":0,"blurHeight":0};